<form [formGroup]="filterForm" class="advanced-filter-container">
    <div class="row gap-2 flex flex-wrapgap-2">
        <p-multiselect 
            formControlName="selectedBrands" 
            inputId="brand-multiselect"
            [showClear]="false" 
            [options]="(brands$ | async) || []"
            [filter]="true"
            (onFilter)="onBrandSearch($event)"
            (onChange)="onBrandChange($event)"
            (onPanelHide)="onBrandPanelHide()"
            class="fixed-width-select"
            autofocusFilter="false"
            display="chip"
            [selectedItemsLabel]="'{0} brands selected'"
            optionLabel="name"
            [loading]="isBrandLoading"
            [placeholder]="brandPlaceholder"
            styleClass="filter-multiselect"/>


        <p-multiselect 
            formControlName="selectedHotels" 
            inputId="hotel-multiselect"
            [showClear]="false"
            [options]="(hotels$ | async) || []"
            [style]="{'minWidth':'180px', 'width': '180px'}"
            panelStyleClass="hotel-filter-multiselect-panel"
            [panelStyle]="{
                'max-width': '290px', 
                'overflow-x': 'auto', 
                'overflow-y': 'auto', 
                'white-space': 'nowrap',
            }"
            appendTo="body"
            [virtualScrollItemSize]="50"
            [virtualScroll]="true"
            [filter]="true"
            (onFilter)="onHotelSearch($event)"
            (onChange)="onHotelChange($event)"
            (onPanelHide)="onHotelPanelHide()"
            autofocusFilter="false"
            display="chip"
            [showToggleAll]="!selectSingleHotel"
            [selectedItemsLabel]="'{0} hotels selected'"
            optionLabel="displayName" 
            [loading]="isHotelLoading"
            [placeholder]="hotelPlaceholder"
            styleClass="filter-multiselect"
            class="fixed-width-select"/>

        <p-button class="" label="All Filters" icon="pi pi-filter" outlined (onClick)="toggleAdvancedFilterDrawer()"></p-button>

        <!-- <cwa-date-picker [view]="'month'" [enableCompare]="true" (dateSelected)="onDateChange($event)" (defaultDate)="onDateChange($event)" /> -->


    </div>
</form>

<p-drawer #advancedFilterDrawer [(visible)]="drawerVisible" (onHide)="drawerVisible = false" position="right" 
    [transitionOptions]="'200ms cubic-bezier(0, 0, 0.2, 1)'" styleClass="w-full sm:w-25rem" headerClass="custom-drawer-header">
    <ng-template #header>
        <div class="flex flex-column">
            <div class="flex align-items-center gap-2">
                <span class="font-semibold text-xl">All Filters</span>
            </div>
            <p class="text-xs text-color-secondary m-0">Applied across every page</p>
        </div>
    </ng-template>

    <div class="flex flex-column gap-4">
        <!-- Enterprise Filter -->
        <div>
            <div class="mb-2">
                <label for="enterprise-multiselect" class="block text-sm mb-0"><span class="font-bold">Enterprise</span><span class="text-xs text-color-secondary ml-2">Multi-select</span></label>
            </div>
            <p-multiselect 
                [formControl]="filterForm.controls.selectedEnterprises"
                inputId="enterprise-multiselect"
                [showClear]="false"
                [options]="(enterprises$ | async) || []"
                [filter]="true"
                (onFilter)="onEnterpriseSearch($event)"
                (onChange)="onEnterpriseChange($event)"
                (onPanelHide)="onEnterprisePanelHide()"
                optionLabel="name"
                autofocusFilter="false"
                [loading]="isEnterpriseLoading"
                display="comma"
                [selectedItemsLabel]="'{0} enterprises selected'"
                [placeholder]="enterprisePlaceholder"
                styleClass="w-full" />
            
            <!-- Selected Enterprise Chips -->
            <div class="flex flex-wrap gap-2 mt-2" *ngIf="filterForm.value.selectedEnterprises?.length">
                <p-chip 
                    *ngFor="let enterprise of filterForm.value.selectedEnterprises!.slice(0, 2)"
                    [label]="enterprise.name" 
                    [removable]="true"
                    (onRemove)="removeEnterpriseChip(enterprise.id)"
                    styleClass="enterprise-chip" />
                <p-chip 
                    *ngIf="hasRemainingItems('enterprises')"
                    [label]="getRemainingCount('enterprises')"
                    [removable]="false"
                    styleClass="enterprise-chip count-chip" />
            </div>
        </div>

        <!-- Divider with Icon -->
        <div class="flex align-items-center gap-2">
            <i class="pi pi-filter text-sm text-color-secondary"></i>
            <span class="text-xs text-color-secondary">FILTERS</span>
            <div class="flex-1 border-top-1 surface-border"></div>
        </div>

        <!-- Owner Filter -->
        <div>
            <div class="mb-2">
                <label for="owner-select" class="block text-sm mb-0"><span class="font-bold">Owner</span><span class="text-xs text-color-secondary ml-2">Multi-select</span></label>
            </div>
            <p-multiselect 
                [formControl]="filterForm.controls.selectedOwners"
                inputId="owner-select"
                [showClear]="false" 
                [options]="(owners$ | async) || []"
                [filter]="true"
                (onFilter)="onOwnerSearch($event)"
                (onChange)="onOwnerChange($event)"
                (onPanelHide)="onOwnerPanelHide()"
                autofocusFilter="false"
                display="comma"
                [selectedItemsLabel]="'{0} owners selected'"
                optionLabel="groupName"
                placeholder="Select Owner"
                styleClass="w-full" />
            
            <!-- Selected Owner Chips -->
            <div class="flex flex-wrap gap-2 mt-2" *ngIf="filterForm.value.selectedOwners?.length">
                <p-chip 
                    *ngFor="let owner of filterForm.value.selectedOwners!.slice(0, 2)"
                    [label]="owner.groupName" 
                    [removable]="true"
                    (onRemove)="removeOwnerChip(owner.id)"
                    styleClass="owner-chip" />
                <p-chip 
                    *ngIf="hasRemainingItems('owners')"
                    [label]="getRemainingCount('owners')"
                    [removable]="false"
                    styleClass="owner-chip count-chip" />
            </div>
        </div>

        <!-- Region Filter -->
        <div>
            <div class="mb-2">
                <label for="region-select" class="block text-sm mb-0"><span class="font-bold">Region</span><span class="text-xs text-color-secondary ml-2">Multi-select</span></label>
            </div>
            <p-multiselect 
                [formControl]="filterForm.controls.selectedRegions"
                inputId="region-multiselect"
                [showClear]="false"
                [options]="(regions$ | async) || []" 
                [filter]="true"
                (onFilter)="onRegionSearch($event)"
                (onChange)="onRegionChange($event)"
                (onPanelHide)="onRegionPanelHide()"
                optionLabel="regionName"
                autofocusFilter="false"
                display="comma"
                [selectedItemsLabel]="'{0} regions selected'"
                placeholder="Select Region"
                styleClass="w-full" />
            
            <!-- Selected Region Chips -->
            <div class="flex flex-wrap gap-2 mt-2" *ngIf="filterForm.value.selectedRegions?.length">
                <p-chip 
                    *ngFor="let region of filterForm.value.selectedRegions!.slice(0, 2)"
                    [label]="region.regionName" 
                    [removable]="true"
                    (onRemove)="removeRegionChip(region.id)"
                    styleClass="region-chip" />
                <p-chip 
                    *ngIf="hasRemainingItems('regions')"
                    [label]="getRemainingCount('regions')"
                    [removable]="false"
                    styleClass="region-chip count-chip" />
            </div>
        </div>
    </div>

    <!-- Action Buttons -->
    <!-- <div class="flex justify-content-between gap-2 p-3 border-top-1 surface-border mt-auto">
        <p-button 
            label="Clear" 
            severity="secondary" 
            outlined 
            size="small"
            (onClick)="clearAndCloseFilters()" />
        
        <p-button 
            label="Apply" 
            size="small"
            (onClick)="onFilterButtonClick()" />
    </div> -->
</p-drawer>
